/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { ChangeEvent, useEffect, useState } from 'react';
import { ListRowProps } from 'react-virtualized';
import Modal from '../../../../../Common/Components/Modal';
import Textbox from '../../../../../Common/Components/Textbox';
import Checkbox from '../../../../../Common/Components/Checkbox';
import SelectBox from '../../../../../Common/Components/SelectBox';
import Searchbox from '../../../../../Common/Components/Searchbox';

import { SelectBoxItemType } from '../../../../../types/SelectBoxPropsType';
import { AdminCreateUserProps, NewUserStateProp, NewUserValidationProp, CreateUserPostProp } from '../../../../../types/AdminCreateUserProps';
import Utils from '../../../../../utils/Utils';
import { postRequest } from '../../../../../utils/fetch';
import { useAppContext } from '../../../../../utils/AppContext';
import formValidation from '../../../../../utils/form/formValidation';
import { CustomerObject } from '../../../../../types/CustomerObject';
import { SelectedPartner } from '../../../../../types/UsersPageProps';

function AdminSidebarCreateUser(props: AdminCreateUserProps): JSX.Element {
  const { modalOpen, partnersList, customersList, updateCustomers, isSensityUserAdmin, isPartnerUserAdmin, isEndUserAdmin } = props;
  const { addNotification } = useAppContext();
  const [partnerAccountsList, setPartnerAccountsList] = useState(customersList);
  const listWidth = 200;
  const listRowHeight = 41;
  const searchBoxMaxItems = 4;
  const [selectedPartner, setSelectedPartner] = useState({ id: '', name: '' });
  const [searchPartner, setSearchPartner] = useState(selectedPartner?.name || '');
  const [createNewUser, setCreateNewUser] = useState<NewUserStateProp>({
    username: '',
    account: { title: '', key: '' },
    roles: { title: '', key: '' },
    firstname: '',
    lastname: '',
    mobile: '1',
    mfa: false,
  });

  const [createUserValidation, setCreateUserValidation] = useState<NewUserValidationProp>({
    emailError: false,
    emailErrorMessage: '',
    accountError: false,
    accountErrorMessage: '',
    mobileError: false,
    mobileErrorMessage: '',
    mfaError: false,
    mfaErrorMessage: '',
    roleError: false,
    roleErrorMessage: '',
    partnerError: false,
    partnerErrorMessage: '',
    firstnameError: false,
    firstnameErrorMessage: '',
    lastnameError: false,
    lastnameErrorMessage: '',
  });
  const [rolesFilter, setRolesFilter] = useState([{ title: 'None', key: '0' }]);

  const setEmail = (newName?: string) => {
    const username = newName !== undefined ? newName : createNewUser.username;
    const validation = formValidation(
      username,
      { required: true, email: true },
    );
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      username,
    }));
    setCreateUserValidation((oldValues) => ({
      ...oldValues,
      emailError: validation.hasError,
      emailErrorMessage: validation.errorMsg,
    }));
  };

  const setFirstname = (newName?: string) => {
    const firstname = newName !== undefined ? newName : createNewUser.firstname;
    const validation = formValidation(
      firstname,
      { required: true },
    );
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      firstname,
    }));
    setCreateUserValidation((oldValues) => ({
      ...oldValues,
      firstnameError: validation.hasError,
      firstnameErrorMessage: validation.errorMsg,
    }));
  };

  const setLastname = (newName?: string) => {
    const lastname = newName !== undefined ? newName : createNewUser.lastname;
    const validation = formValidation(
      lastname,
      { required: true },
    );
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      lastname,
    }));
    setCreateUserValidation((oldValues) => ({
      ...oldValues,
      lastnameError: validation.hasError,
      lastnameErrorMessage: validation.errorMsg,
    }));
  };

  const setRole = (newName?: SelectBoxItemType) => {
    const roles = newName !== undefined ? newName : createNewUser.roles;
    const validation = formValidation(
      roles.key,
      { required: true },
    );
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      roles,
    }));
    setCreateUserValidation((oldValues) => ({
      ...oldValues,
      roleError: validation.hasError,
      roleErrorMessage: validation.errorMsg,
    }));
  };
  const setPartner = (newName?: SelectedPartner) => {
    const partner = newName !== undefined ? newName : selectedPartner;
    const validation = formValidation(
      partner.id,
      { required: true },
    );
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      roles: { title: '', key: '' },
    }));
    setCreateUserValidation((oldValues) => ({
      ...oldValues,
      partnerError: validation.hasError,
      partnerErrorMessage: validation.errorMsg,
      accountError: false,
      accountErrorMessage: '',
    }));
  };

  const mfaErrorMessage = 'Enter mobile number for two-factor authentication.';

  const setMobile = (newName?: string) => {
    if (newName === '' || !newName?.startsWith('1')) {
      // eslint-disable-next-line no-param-reassign
      newName = `1${newName}`;
    }

    const mobile = (newName !== undefined) ? newName : createNewUser.mobile;
    const validation = formValidation(
      mobile,
      { phone: true },
    );
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      mobile,
    }));

    if (createNewUser.mfa && mobile === '1') {
      setCreateUserValidation((oldValues) => ({
        ...oldValues,
        mfaError: true,
        mfaErrorMessage,
        mobileError: false,
        mobileErrorMessage: '',
      }));
    } else {
      setCreateUserValidation((oldValues) => ({
        ...oldValues,
        mfaError: false,
        mfaErrorMessage: '',
        mobileError: validation.hasError,
        mobileErrorMessage: validation.errorMsg,
      }));
    }
  };

  const checkMobileSelected = (checked?:boolean) => {
    const validationError = ((createNewUser.mobile === '') || (createNewUser.mobile === '1'));
    const validationErrorMsg = ((createNewUser.mobile === '') || (createNewUser.mobile === '1')) ? mfaErrorMessage : '';
    const mfa = !createNewUser.mfa;
    setCreateNewUser((oldValues) => ({
      ...oldValues,
      mfa,
    }));

    if (checked) {
      setCreateUserValidation((oldValues) => ({
        ...oldValues,
        mfaError: validationError,
        mfaErrorMessage: validationErrorMsg,
      }));
    } else {
      setCreateUserValidation((oldValues) => ({
        ...oldValues,
        mfaError: false,
        mfaErrorMessage: '',
      }));
    }
  };
  const checkPartnerSelected = (partneruser?:boolean, newName?: SelectBoxItemType) => {
    const account = newName !== undefined ? newName : createNewUser.account;
    if (!partneruser) {
      const validationError = (selectedPartner.id === '');
      const validationErrorMsg = (selectedPartner.id === '') ? 'Please select a partner' : '';
      if (validationError) {
        setCreateNewUser((oldValues) => ({
          ...oldValues,
          roles: { title: '', key: '' },
        }));
        setCreateUserValidation((oldValues) => ({
          ...oldValues,
          accountError: validationError,
          accountErrorMessage: validationErrorMsg,
        }));
      } else {
        setCreateNewUser((oldValues) => ({
          ...oldValues,
          account,
          roles: { title: '', key: '' },
        }));
        setCreateUserValidation((oldValues) => ({
          ...oldValues,
          accountError: false,
          accountErrorMessage: '',
        }));
      }
    } else {
      setCreateNewUser((oldValues) => ({
        ...oldValues,
        account,
        roles: { title: '', key: '' },
      }));
      setCreateUserValidation((oldValues) => ({
        ...oldValues,
        accountError: false,
        accountErrorMessage: '',
      }));
    }
  };

  useEffect(() => {
    if (isSensityUserAdmin && selectedPartner.name === 'Sensity Systems') {
      setRolesFilter(Utils.getUserRolesByType('sensity'));
    } else if (((isPartnerUserAdmin) || (isSensityUserAdmin && selectedPartner.id !== '')) && createNewUser.account.key === '') {
      setRolesFilter(Utils.getUserRolesByType('partner'));
    } else if ((createNewUser.account.key !== '') || (isEndUserAdmin)) {
      setRolesFilter(Utils.getUserRolesByType('account'));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedPartner,
    createNewUser.account,
  ]);

  useEffect(() => {
    if (selectedPartner.id !== '') {
      setCreateNewUser((oldValues) => ({
        ...oldValues,
        account: { title: '', key: '' },
        roles: { title: '', key: '' },
      }));
      if (createUserValidation.partnerError) {
        setCreateUserValidation((oldValues) => ({
          ...oldValues,
          partnerError: false,
          partnerErrorMessage: '',
        }));
      }
      setPartnerAccountsList(customersList.filter((partneraccount) => (partneraccount.type !== 'partner') && (partneraccount.po === selectedPartner.id)));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedPartner,
    customersList,
  ]);
  const [filteredPartnerList, setFilteredPartnerList] = useState(partnersList);
  const partnerRowRenderer = ({ key, index, style }: ListRowProps, setToggle: React.Dispatch<React.SetStateAction<boolean>>) => {
    if (!filteredPartnerList) {
      return <></>;
    }

    const { name } = filteredPartnerList[index];

    return (
      <li
        key={key}
        style={style}
        className="search-partner--list"
        onClick={() => {
          setToggle(false);
          setSearchPartner(name);
          setSelectedPartner({ id: filteredPartnerList[index].orgid, name });
        }}
      >
        <span className={name === selectedPartner?.name ? 'selected' : ''}>{name || ''}</span>
      </li>
    );
  };
  const handlePartnerListChange = (name: string) => {
    setSearchPartner(name);

    if (name === '') {
      setSelectedPartner({ id: '', name: '' });
      setFilteredPartnerList(partnersList);
    } else {
      setFilteredPartnerList(partnersList?.filter((item: CustomerObject) => item.name.toLowerCase().includes(name.toLowerCase())));
    }
  };
  const endUserAdminWidth = 350;
  const otherAdminWidth = 300;
  const addEndUserClass = isEndUserAdmin ? 'enduser' : '';
  const selectBoxWidth = (isEndUserAdmin) ? endUserAdminWidth : otherAdminWidth;
  const partnerDrop = (isSensityUserAdmin)
    ? (
      <>
        <span className="search-partnerdropdown__label"> Partner </span>
        <Searchbox
          label="Partner"
        // onClick={(item: SelectBoxItemType) => setPartner(item)}
          searchValue={searchPartner}
          onChange={(event: ChangeEvent<HTMLInputElement>) => handlePartnerListChange(event.target.value)}
          list={Utils.arrayToSelectbox(filteredPartnerList || [], 'orgid', 'name')}
          title={selectedPartner.name || 'Select'}
          listWidth={listWidth}
          listRowHeight={listRowHeight}
          listRowRenderer={partnerRowRenderer}
          rowNumber={searchBoxMaxItems}
          iconClickToggleList
          className={createUserValidation.partnerError ? 'search-partnerdropdown error' : 'search-partnerdropdown'}
        />
        {
          createUserValidation.partnerError && (
          <span className="search-partnerdropdown__errormessage">
            {createUserValidation.partnerErrorMessage}
          </span>
          )
        }
      </>
    )
    : (
      <Textbox
        label="Partner"
        value={partnersList[0]?.name}
        placeholder={partnersList[0]?.name}
        disabled
        gridTemplateColumns={`auto ${selectBoxWidth}px`}
      />
    );

  return (
    <div className="user-interactions create-user">
      <Modal
        title="Create new user"
        setModalOpen={modalOpen}
        primaryButtonLabel="Create"
        primaryButtonAction={async () => {
          const currentUser = createNewUser;
          if (currentUser.username === '') {
            setEmail(currentUser.username);
            return;
          }
          if (currentUser.firstname === '') {
            setFirstname(currentUser.firstname);
            return;
          }
          if (currentUser.lastname === '') {
            setLastname(currentUser.lastname);
            return;
          }
          if (isSensityUserAdmin && selectedPartner.id === '') {
            setPartner(selectedPartner);
            return;
          }
          if (currentUser.roles.key === '') {
            setRole(currentUser.roles);
            return;
          }
          if (createUserValidation.mfaError || createUserValidation.mobileError) {
            return;
          }
          try {
            const phone = currentUser.mobile === '' || currentUser.mobile === '1' ? null : currentUser.mobile;
            const roles = currentUser.roles.key.toUpperCase();

            const postBody: CreateUserPostProp = {
              email: currentUser.username,
              name: `${currentUser.firstname} ${currentUser.lastname}`.trimEnd(),
              phone,
              mfa: currentUser.mfa,
            };
            const selectedPartnerVal = (isPartnerUserAdmin) ? partnersList[0].orgid : selectedPartner.id;
            const selectedPartnerAccount = (currentUser.account.key !== '') ? currentUser.account.key : selectedPartnerVal;
            const selectedCustomerId = (isEndUserAdmin) ? customersList[0].orgid : selectedPartnerAccount;
            const result = await postRequest(
              `/organizations/${selectedCustomerId}/users?targetRole=${roles}`,
              postBody,
            );

            if (!result.error) {
              addNotification({ type: 'info', message: 'Your "Create user" operation is completed.' });
              if (updateCustomers) {
                updateCustomers();
              }
            } else {
              addNotification({ type: 'error', message: `Your "Create user" operation has failed: ${result.error}` });
            }
          } catch (e) {
            addNotification({ type: 'error', message: 'Your "Create user" operation has failed.' });
          }
          modalOpen(false);
        }}
        secondaryButtonLabel="Cancel"
        width={(isEndUserAdmin ? '410' : '710')}
        secondaryButtonAction={() => modalOpen(false)}
      >
        <div className={`modal-divided ${addEndUserClass || ''}`}>
          <div className="modal-divided__leftcontent">
            <div className="modal-divided__content-data">
              { (!isEndUserAdmin)
                && (
                <div>
                  {partnerDrop}
                  <SelectBox
                    label="Account"
                    onClick={(item: SelectBoxItemType) => {
                      checkPartnerSelected(isPartnerUserAdmin, item);
                    }}
                    selectedItemKey={createNewUser?.account?.key || ''}
                    list={Utils.arrayToSelectbox(partnerAccountsList || [], 'orgid', 'name')}
                    title={createNewUser.account.title || 'Select'}
                    type="light"
                    error={createUserValidation.accountError}
                    errorMessage={createUserValidation.accountErrorMessage}
                    listWidth={selectBoxWidth}
                  />
                </div>
                )}
              <SelectBox
                label="Role"
                onClick={(item: SelectBoxItemType) =>
                  setCreateNewUser((oldValues) => ({ ...oldValues, roleError: false, roleErrorMessage: '', roles: item }))}
                selectedItemKey={createNewUser?.roles?.key || ''}
                list={Utils.arrayToSelectbox(rolesFilter || [], 'key', 'title')}
                title={createNewUser.roles.title || 'Select'}
                isRequired
                error={createUserValidation.roleError}
                errorMessage={createUserValidation.roleErrorMessage}
                type="light"
                listWidth={selectBoxWidth}
              />
              <Textbox
                label="Username (Email)"
                name="Email"
                value={createNewUser.username}
                placeholder="Enter"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                isRequired
                error={createUserValidation.emailError}
                errorMessage={createUserValidation.emailErrorMessage}
                gridTemplateColumns={`auto ${selectBoxWidth}px`}
              />
            </div>
          </div>
          <div className="modal-divided__rightcontent">
            <Textbox
              label="First name"
              name="FirstName"
              value={createNewUser.firstname}
              placeholder="Enter"
              onChange={(event) => {
                setFirstname(event.target.value);
              }}
              isRequired
              error={createUserValidation.firstnameError}
              errorMessage={createUserValidation.firstnameErrorMessage}
              gridTemplateColumns={`auto ${selectBoxWidth}px`}
            />
            <Textbox
              label="Last name"
              name="LastName"
              value={createNewUser.lastname}
              placeholder="Enter"
              onChange={(event) => {
                setLastname(event.target.value);
              }}
              isRequired
              error={createUserValidation.lastnameError}
              errorMessage={createUserValidation.lastnameErrorMessage}
              gridTemplateColumns={`auto ${selectBoxWidth}px`}
            />
            <Textbox
              label="Mobile (SMS)"
              name="Mobile"
              value={createNewUser.mobile}
              placeholder="Enter"
              onChange={(event) => {
                setMobile(event.target.value);
              }}
              error={createUserValidation.mfaError || createUserValidation.mobileError}
              errorMessage={createUserValidation.mfaErrorMessage || createUserValidation.mobileErrorMessage}
              gridTemplateColumns={`auto ${selectBoxWidth}px`}
            />
            <div className="users-mfa">
              <span>Multi-factor authentication (MFA)</span>
              <div className="mfa-content">
                <Checkbox
                  checked={createNewUser.mfa}
                  onClick={(checked) => {
                    checkMobileSelected(checked);
                  }}
                />
                <span>Required</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AdminSidebarCreateUser;
